import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AssessorAuthContext } from '../context/AssessorAuthContext';

const AssessorPrivateRoute = ({ children }) => {
  const { assessor, loading } = useContext(AssessorAuthContext);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Checking access...</p>
      </div>
    );
  }

  if (!assessor) {
    return <Navigate to="/login?portal=assessor" replace />;
  }

  return children;
};

export default AssessorPrivateRoute;
